const API = process.env.REACT_APP_API_URL || "";
export default API;
